import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="image-preview"
export default class extends Controller {
  static targets = ["input", "preview", "placeholder"]

  connect() {
    // Если есть инпут, добавляем слушатель
    if (this.hasInputTarget) {
      this.inputTarget.addEventListener("change", this.previewImage.bind(this))
    }
  }

  previewImage(event) {
    const file = event.target.files[0]
    
    if (file) {
      // Проверяем, что это изображение
      if (file.type.startsWith('image/')) {
        const reader = new FileReader()
        
        reader.onload = (e) => {
          if (this.hasPreviewTarget) {
            this.previewTarget.src = e.target.result
            this.previewTarget.style.display = 'block'
          }
          
          if (this.hasPlaceholderTarget) {
            this.placeholderTarget.style.display = 'none'
          }
        }
        
        reader.readAsDataURL(file)
      } else {
        // Если файл не изображение, показываем ошибку
        alert('Пожалуйста, выберите файл изображения (JPEG, PNG, GIF)')
        event.target.value = ''
      }
    } else {
      // Если файл не выбран, возвращаем к исходному состоянию
      this.resetPreview()
    }
  }

  clearImage(event) {
    event.preventDefault()
    
    // Очищаем input
    if (this.hasInputTarget) {
      this.inputTarget.value = ''
    }
    
    // Сбрасываем превью
    this.resetPreview()
  }

  resetPreview() {
    if (this.hasPreviewTarget) {
      this.previewTarget.style.display = 'none'
      this.previewTarget.src = ''
    }
    
    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.style.display = 'block'
    }
  }
}
